import { Redirect } from 'expo-router';

import { routes } from '@fhs-legacy/frontend/src/utils/routing';

/**
 * The legacy support category pages are no longer supported (the support chatbot replaced them).
 * Send anyone landing here to the chatbot support page.
 */
export default function SupportCategoryRedirect() {
  return <Redirect href={routes.support} />;
}
